export default __webpack_public_path__ + "static/media/wip@2x.8eeaa7a8.png";